import axios from 'axios';

const STORE_URL = 'https://happyboxstore.com';
const MAIN_PRODUCT_TYPE = 'Box';
const ADDON_PRODUCT_TYPE = 'Gift';
const CARD_PRODUCT_TYPE = 'Card';
const COLLECTION_HANDLE = 'build-a-happy-box';
var cartItems = null;

const actions = {
  getFeeProduct(context) {
    axios.get(`/products/handpacking-fee-5.js`)
    .then(response => response.data)
    .then((data) => {
      context.commit('setFeeProduct', data);
    })
  },
  //Get gifts,cards and boxes products
  async getProducts(context) {
    const cartRequest = await axios.get(`${STORE_URL}/cart.js`);
    let cart = cartRequest.data;
    processCart(context,cart);
    axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}.json`)
    .then(response => response.data)
    .then((data) => {
      // Figure out how many pages of data we have to pull
      const numOfPages = Math.ceil(data.collection.products_count / 250);
      fetchProducts(numOfPages, []);
    })
    .catch((err) => {
      console.log('***Error Fetching NumOfProducts***');
    });

    function processCart(context, data){
      context.commit('setCartQty', data.item_count);
      let boxes = data.items.filter(x => x.properties.boxName);
      if(boxes.length > 0){
        let boxNames = boxes.map(x => x.properties.boxName);
        context.commit('setCartNames', boxNames);
      }
      let items = data.items.flatMap(x =>{
        if(x.product_type == "GIST_BUILDER_PRODUCT"){
          let ids = [];
          let qtys = [];
          if(!Array.isArray(x.properties._gs_bundle_ids))
            ids = x.properties._gs_bundle_ids.split(",");
          else
            ids = x.properties._gs_bundle_ids;
          if(!Array.isArray(x.properties._gs_bundle_ids))
            qtys = x.properties._gs_bundle_quantities.split(",");
          else
            qtys = x.properties._gs_bundle_quantities;
          return ids.map((id,i) => {
            return {id: id, quantity: parseInt(qtys[i]) * x.quantity}
          })
        }
        else {
          return [{id: x.variant_id, quantity:x.quantity}]
        }
      })

      let groupedItems = [];
      items.forEach(item => {
        // Find if the item with the same id already exists in the result array
        const existingItem = groupedItems.find(resultItem => resultItem.id === item.id);
        if (existingItem) {
          // If it exists, add the quantity to the existing item's quantity
          existingItem.quantity += item.quantity;
        } else {
          // If it doesn't exist, push a new item to the result array
          groupedItems.push({ id: item.id, quantity: item.quantity });
        }
      });

      cartItems = groupedItems;
    }

    function fetchProducts(pageNum, productList) {
      // Recursive function that gets the full list of products
      if (pageNum != 0) {
        axios.get(`${STORE_URL}/collections/${COLLECTION_HANDLE}/products.json?limit=250&page=${pageNum}`)
          .then(response => response.data)
          .then((data) => {
            const updatedProductList = [...data.products, ...productList];
            fetchProducts(pageNum - 1, updatedProductList);
          })
          .catch((err) => {
            console.log('***Error Fetching Products***');
          });
      } else {
        sortFetchedProducts(productList);
      }
    }

    function sortFetchedProducts(totalProductList) {
      axios.get('https://api.happyboxstore.com/api/bundle/getGiftProducts')
      .then(response => response.data)
      .then((data) => {
        totalProductList =  totalProductList.map((item, i) => Object.assign({}, item, data.find(x => x.id == item.id)));
        const mainProductList = totalProductList.filter((product) => {
          if (product.product_type == MAIN_PRODUCT_TYPE && product.variants.some(x => x.inventory_quantity > 0 || x.inventory_policy == "continue")) {
            product.maxCapacity = parseInt(product.variants[0].option1);
            product.variants = product.variants.map((variant) =>{
              let cart = cartItems.find(x => x.id == variant.id);
              if(cart){
                variant.inventory_quantity = variant.inventory_quantity - cart.quantity;
              }
              variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
              variant.available = variant.inventory_quantity > 0;
              return variant
            })
            return product;
          }
          else if(product.product_type == MAIN_PRODUCT_TYPE && product.title.toLowerCase().includes("custom")){
            product.variants = product.variants.map((variant) =>{
              variant.available = true;
              variant.inventory_quantity = 999;
              return variant
            })

            return product;
          }
        });

        var addonProductList = totalProductList.filter((product) => {
          if (product.product_type == ADDON_PRODUCT_TYPE && (product.variants.some(x => x.inventory_quantity > 0) || product.variants.some(x => x.inventory_policy == "continue"))) {
            product.tags = product.tags.split(', ')
            const capacityTag = product.tags.find(tag => tag.indexOf('Capacity_') > -1);
            if (capacityTag != undefined) {
              const capacity = parseFloat(capacityTag.split('_')[1]);
              product.capacity = capacity;
            }

            const isOnSale = product.variants.some(x => x.compare_at_price != null);
            if(isOnSale){
              product.tags.push("Filter_Category_Sale")
            }
            product.variants = product.variants.filter(x => parseFloat(x.price) > 0).map((variant) =>{
              let cart = cartItems.find(x => x.id == variant.id);
              if(cart){
                variant.inventory_quantity = variant.inventory_quantity - cart.quantity;
              }
              variant.inventory_quantity = variant.inventory_policy == "continue" ? 9999 : variant.inventory_quantity;
              variant.available = variant.inventory_quantity > 0;
              variant.sku = variant.sku ? variant.sku : "";
              variant.featured_image = product.images.find(x => x.id == variant.image_id)
              return variant
            })
  
            return product;
          }
        });

        addonProductList = addonProductList.filter(x => x.variants && x.variants.length > 0);
  
        const cardProductList = totalProductList.filter(product => (product.product_type == CARD_PRODUCT_TYPE && product.variants.some(x => x.inventory_quantity > 0 || x.inventory_policy == "continue" ))).map((x) =>{
          const isVertical = x.tags.includes("Vertical");
          x.isVertical = isVertical;

          return x;
        });
        var capacityList = mainProductList.map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1));
        let maxCapacity = Math.max(...capacityList);
        context.commit('setMainProducts', JSON.parse(JSON.stringify(context.getters.boxProducts.concat(mainProductList))));
        context.commit('setAddonProducts', JSON.parse(JSON.stringify(context.getters.addonProducts.concat(addonProductList))));
        context.commit('setCardProducts', JSON.parse(JSON.stringify(context.getters.cardProducts.concat(cardProductList))));
        if(context.getters.maxCapacity < maxCapacity){
          context.commit('setMaxCapacity', maxCapacity);
        }
        //Get occasions
        getOccasions(context.state.addonProducts);
      })
      .catch((err) => {
        console.log(err);
        console.log('***Error Fetching NumOfProducts***');
      });
    }
    function getOccasions(addonProductList){
      var tags = [...new Set(addonProductList.flatMap(x => x.tags.filter(y => y.includes("Filter_") )))];
      if(tags.length > 0){
        tags = tags.map((x) =>{
          const currentArray = x.replace("Filter_","").split("_");
          if (currentArray.length > 1){
            var currentObject = { category: currentArray[0], title: currentArray[1], tag: x };
            return currentObject;
          }
        })
        var sortedFilters = [];
        sortedFilters = [...tags.reduce((hash, {category,title,tag}) => {
          const current = hash.get(category) || { category, filters: [] };
          current.filters.push({ title, tag });
          return hash.set(category, current);
        }, new Map).values()];

        let occasions = sortedFilters.find(x => x.category == "Occasion");
        context.commit('setOccasions', occasions.filters);
        let categories = sortedFilters.find(x => x.category == "Category");
        let corpCategory = `${context.getters.corpName} Gifts`;
        categories.filters.sort((a,b) => {
          if (a.title == "Sale"){
            return 1
          }
          else if(b.title == "Sale"){
            return -1
          }
          else{
            let aValue =  a.title == corpCategory ? 5 : (a.title == "Snacks & Treats" ? 4 : (a.title == "Brandable Swag" ? 3 : (a.title == "Tea/Coffee" ? 2 : (a.title == "Candles" ? 1 : 0))));
            let bValue =  b.title == corpCategory ? 5 : (b.title == "Snacks & Treats" ? 4 : (b.title == "Brandable Swag" ? 3 : (b.title == "Tea/Coffee" ? 2 : (b.title == "Candles" ? 1 : 0))));
            return bValue - aValue;
          }
        });
        categories.filters.unshift({title: "View All", tag: "Filter_Category_View All"});
        context.commit('setCategories', categories);
      }
    }
  },
};

export default actions;
